<script>
  import { Main } from 'element-ui'
  export default {
    name:'ElMain',
    extends:Main
  }
</script>
